import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "boundary-plus-upsell" }
const _hoisted_2 = { class: "boundary-plus-upsell__container" }
const _hoisted_3 = { class: "boundary-plus-upsell__text" }
const _hoisted_4 = { class: "boundary-plus-upsell__heading" }
const _hoisted_5 = { class: "boundary-plus-upsell__body" }
const _hoisted_6 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString($props.heading), 1 /* TEXT */),
        _createElementVNode("p", _hoisted_5, _toDisplayString($props.body), 1 /* TEXT */)
      ]),
      _createElementVNode("a", {
        href: $setup.subscribe_email_href,
        class: "button button--fill boundary-plus-upsell__cta"
      }, " Subscribe to Boundary + ", 8 /* PROPS */, _hoisted_6)
    ])
  ]))
}